import { IsNumber, IsOptional, IsString } from 'class-validator';

export class TreasuryBankingTransferRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsNumber()
  @IsOptional()
  businessEntityBankId?: number;

  @IsString()
  @IsOptional()
  recipientIban?: string;

  @IsNumber()
  @IsOptional()
  recipientIcan?: number;

  @IsString()
  @IsOptional()
  recipientAccountName?: string;

  @IsString()
  @IsOptional()
  recipientSortCode?: string;

  @IsString()
  @IsOptional()
  recipientAccountNumber?: string;

  @IsNumber()
  amount: number;

  @IsString()
  yourRef: string;

  @IsString()
  myRef: string;
}
